import React from "react";
import "./FormVehicle.css";
import "./FormClientInfo.css";
import { makeStyles } from "@material-ui/core";
import CalendarPicker from "../calendarpicker/CalendarPicker.js"

const QUOTE_SAVED_SUCCESS_MSG = "ok";

const useStyles = makeStyles((theme) => ({

  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    width: "100%",
  },

}));

function FormClientInfo({ nextStep, prevStep, formHeading, showFailPage, quote, vehicleList, disabledDays }) {
  const [clientName, setClientName] = React.useState();
  const [email, setEmail] = React.useState();
  const [contact, setContact] = React.useState();
  const [specInstr, setSpecInstr] = React.useState();
  const [prefCollectionDate, setPrefCollectionDate] = React.useState("");

  const classes = useStyles();

  React.useEffect(() => {
    quote.clientName = clientName;
    quote.clientEmail = email;
    quote.clientPhone = contact;
    quote.clientRemarks = specInstr;
    quote.prefCollectionDate = prefCollectionDate;
  }, [clientName, email, contact, specInstr, prefCollectionDate]);

  function setDate(dateStr) {
    setPrefCollectionDate(dateStr);
  }

  async function saveQuote() {
    quote.vehicleList = vehicleList;
    const data = JSON.stringify(quote);
    console.log(data);
    fetch("https://moveit.motorvia.co.za/moveit2/c/quotes/createquote", {
      method: "POST",
      headers: new Headers({ "Content-Type": "application/json" }),
      body: data
    }).then((resp) => {
      resp.text().then((msg) => {
        if (resp.status === 200 && msg === QUOTE_SAVED_SUCCESS_MSG) {
          nextStep();
        } else if (resp.status === 422 && msg !== QUOTE_SAVED_SUCCESS_MSG) {
          window.alert(msg);
        } else {
          showFailPage();
        }
      }).catch((err) => {
        console.log(err);
        showFailPage();
      });
    });
  }

  return (
    <div className="formRouteMainContainer">
      <div className="formVehicleContainer">
        <div className="formVehicleHeader">
          <div className="formVehicleHeaderContent">{formHeading}</div>
        </div>
        <div className="formClientInfoContent">
          <div className="formClientInfoInputs">
            <input
              className="formClientInfoInput"
              type="text"
              placeholder="Name"
              onChange={(evt) => {
                setClientName(evt.target.value);
              }}
            />
          </div>
          <div className="formClientInfoInputs">
            <input
              className="formClientInfoInput"
              type="text"
              placeholder="Email"
              onChange={(evt) => setEmail(evt.target.value)}
            />
          </div>
          <div className="formClientInfoInputs">
            <input
              className="formClientInfoInput"
              type="text"
              placeholder="Contact Number"
              onChange={(evt) => setContact(evt.target.value)}
            />
          </div>
          <div className="formClientInfoInputs">
            <CalendarPicker parseDate={setDate} disabledDays={disabledDays} />
          </div>
          <div className="formClientInfoInputs">
            <textarea
              className="SI"
              type="text"
              placeholder="Special Instructions"
              onChange={(evt) => setSpecInstr(evt.target.value)}
            />
          </div>
          <div className="buttonSpacer"></div>
        </div>
        <div className="btn-container">
          <button className="btn-prev" onClick={prevStep}>
            Previous
          </button>
          <button className="btn-next" onClick={saveQuote}>
            Complete
          </button>
        </div>

      </div>

    </div>
  );
}

export default FormClientInfo;
